// @flow

export const APPLICATION_STATUSES = {
  NEW: /* Status */ getText('New Application'),
  YES: /* Status */ getText('Move Forward'),
  MAYBE: /* Status */ getText('Under Consideration'),
  NO: /* Status */ getText('Screen Out')
};
